import { API_BASE_URL } from "config";
import { StatusCodes } from "http-status-codes";

import { BaseService } from "./base-service";

/**
 * Implements user Validation, Authorization and Authentication.
 */
export class CSRFService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  public async getToken(): Promise<string> {
    const response = await this.fetch("/csrf");
    if (response.status !== StatusCodes.OK) {
      throw new Error("An error occurred getting CSRF token.");
    }
    const jsonResponse = await response.json();
    return jsonResponse.token as string;
  }
}
